import NetworkLogic from "../../Shared/NetworkLogic";
import RemoteSprite from "../../Common/RemoteSprite";
import Player from "../../Models/Player";
import AudioManager from "../../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ChangeHeadUI extends cc.Component {
    @property(cc.Layout)
    lytContent: cc.Layout = null

    @property(cc.Node)
    nodeTemplateHead: cc.Node = null

    @property(RemoteSprite)
    rspHead: RemoteSprite = null

    private _selectedHeadCfg = null

    onLoad () {
        this.nodeTemplateHead.parent = null
    }

    start () {
        NetworkLogic.getListPhoto(function (data) {
            this.createHeads(data)
        }.bind(this))
    }

    onDestroy () {
        this.nodeTemplateHead.destroy()
    }

    onBtnClick (event, userData) {
        if (userData === "ok") {
            NetworkLogic.editUserImage(this._selectedHeadCfg.imageId, function () {
                Player.setPy("head", this._selectedHeadCfg.imageUrl)
                this.node.destroy()
            }.bind(this))
        }else if (userData === "close") {
            AudioManager.playSound("close")
            this.node.destroy()
        }
    }

    onToggleSelete (toggle: cc.Toggle) {
        this.rspHead.url = toggle.node["headConfig"].imageUrl
        this._selectedHeadCfg = toggle.node["headConfig"]
    }

    private createHeads (cfgs) {
        for (let i = 0; i < cfgs.length; i++) {
            const cfg = cfgs[i];
            let toggle = cc.instantiate(this.nodeTemplateHead).getComponent(cc.Toggle)
            toggle.node.parent = this.lytContent.node
            toggle.node["headConfig"] = cfg
            toggle.node.getChildByName("head").getComponent(RemoteSprite).url = cfg.imageUrl
            
            if (i === 0 || cfg.imageUrl === Player.getPy("head")) {
                toggle.isChecked ? this.onToggleSelete(toggle) : toggle.isChecked = true
            }
        }
    }
}
